import React, { useCallback, useEffect, useState } from "react";
import BuySellBtn from "../CommonTocComponent/Stock/BuySellBtn";
import MarginReqAvail from "../CommonTocComponent/Stock/MarginReqAvail";
import TermsAndConditions from "../CommonTocComponent/Terms&Conditions/TermsAndConditions";
import StockQuote from "../CommonTocComponent/TocHeader/StockQuote";
import TocStockHeader from "../CommonTocComponent/TocHeader/TocStockHeader";
import MarketDepth from "../CommonTocComponent/MarketDepth/MarketDepth";
import ChargesMain from "../CommonTocComponent/Charges/ChargesMain";
import UnderStandingMain from "../CommonTocComponent/UnderstandSection/UnderStandingMain";
import OrderConfirmationMain from "../CommonTocComponent/OrderConfirmation/OrderConfirmationMain";
import { currencyOrder, currencyProducts, currencyValidity, setUISectionsCurrency, } from "./CurrencyConstant";
import CurrencyProductOrder from "./CurrencyProductOrder";
import { useSelector } from "react-redux";
import { CreateTOCbuttonList, getTOCProduct_OrderType_Val, orderData, productData, understandingSectionEnum, } from "../CommonTocComponent/commonTocConstant";
import { CURRENCYIgnoreList, TOCBUYORSELL, } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
import { placeorderDataCurrency } from "../CommonTocComponent/MarketDepth/MarketDepthTabs";
import di from "@frameworks/web/components/features/TOC/di/servicelocator";
import mainDi from "@di";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthToSellJourney, setUISections } from "../Equity/EqTOCFunctionality";
import { eqValidity } from "../Equity/EqConstants";
import { chargesHandler, checkTocState, fieldValidationManager, getProductValues, } from "../constant";
import { OrderbookTocStateEnum, } from "@frameworks/web/components/features/OrderBook/constant";
import { isEqual } from "underscore";
import UnderStanding from "../CommonTocComponent/UnderstandSection/UnderStanding";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import ChartIQTOC from "../CommonTocComponent/ChartIQ/ChartIQTOC";
import { addCommasWithConditionalDecimal, } from "@domains/utils/numberMethods";
const Currency = (props) => {
    var _a, _b;
    const device = DeviceContext();
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const locationState = location.state;
    const [termCondition, setTermCondition] = React.useState(false);
    const [understanding, setUnderstanding] = React.useState(false);
    const [marketDepth, setmarketDepth] = React.useState(false);
    const [charges, setCharges] = React.useState(false);
    const [confirmOrder, setConfirmOrder] = React.useState(false);
    const [margin, setMargin] = React.useState(null);
    const [refreshMargin, setrefreshMargin] = useState(null);
    const [nseBse, setNseBse] = React.useState(placeorderDataCurrency[0].value);
    const [underStandingSectionKey, setUnderStandingSectionKey] = useState(null);
    const [advancedOption, setAdvancedOption] = useState(false);
    const [trailingstop, seTrailingStop] = useState(false);
    const [chartIQ, setChartIQ] = React.useState(false);
    const [buttonList, setButtonList] = useState();
    const [orderType, setOrderType] = useState();
    const [validity, setValidity] = useState();
    const [activeButton, setActiveButton] = useState({
        PRODUCT: currencyProducts[0].value,
        ORDER: currencyOrder[0].title,
        VALIDITY: currencyValidity[0].value,
    });
    const [amoOrder, setAmoOrder] = useState(null);
    const [modifySection, setModifySection] = useState({
        tocState: (locationState === null || locationState === void 0 ? void 0 : locationState.tocState) || (props === null || props === void 0 ? void 0 : props.tocState) || null,
        modifyData: (locationState === null || locationState === void 0 ? void 0 : locationState.modifyData) || (props === null || props === void 0 ? void 0 : props.modifyData) || {},
    });
    const [orderConfirmationBoList, setOrderConfirmationBoList] = useState([]);
    const quotesDetailsEntity = useSelector((state) => state.TOCJourney.multiQuoteReducers.multiQuote.quotesDetailsEntity, isEqual);
    const [tradeValues, setTradeValues] = useState({
        noOfLots: "1",
        limitPrice: "",
        quantity: (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0
            ? (_b = (1 * parseInt((_a = quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.lotSize))) === null || _b === void 0 ? void 0 : _b.toString()
            : "0",
        stopLoss: "",
        target: "",
        triggerPrice: "",
        disclosedQuantity: "",
        trailingstoploss: "",
        agreeToTermsAndCondition: false,
    });
    const [formErrors, setFormErrors] = useState({
        limitPrice: { msg: "", status: false },
        stopLoss: { msg: "", status: false },
        target: { msg: "", status: false },
        triggerPrice: { msg: "", status: false },
        trailingStopLoss: { msg: "", status: false },
        disclosedQuantity: { msg: "", status: false },
    });
    const [IsBuy, setIsBuy] = useState(() => device.isDesktop && (props === null || props === void 0 ? void 0 : props.isBuy)
        ? props === null || props === void 0 ? void 0 : props.isBuy
        : (locationState === null || locationState === void 0 ? void 0 : locationState.isBuy)
            ? locationState === null || locationState === void 0 ? void 0 : locationState.isBuy
            : true);
    const [activeState, setActiveState] = useState(IsBuy ? TOCBUYORSELL.BUY : TOCBUYORSELL.SELL);
    const { data: amo, loader: amoLoader, errorData: amoError, } = useSelector((state) => state.TOCJourney.AMOStatus, isEqual);
    const rmsDetails = useSelector((state) => state.TOCJourney.rmsDetails, isEqual);
    const rmsSublimits = rmsDetails.rmsSublimits;
    /* The above code is using the useSelector hook from the React Redux library to select the userID
    property from the accountDetailsReducer in the Redux store. It is then assigning the value of
    userID to a constant variable with the same name. */
    const { userID: userID } = useSelector((state) => state.accountDetailsReducer, isEqual);
    /* The above code is using the useSelector hook from the React Redux library to select the
   `checkMargin` data from the Redux store. It is destructuring the `data`, `loader`, and `errorData`
   properties from the `checkMargin` object and assigning them to variables `checkMarginData`,
   `checkMarginLoader`, and `checkMarginError` respectively. */
    const { data: checkMarginData, loader: checkMarginLoader, errorData: checkMarginError, } = useSelector((state) => state.TOCJourney.checkMargin, isEqual);
    /**
     * The function `CreatebuttonList` sets the button list, validity, and order type based on the result
     * of the `CreateTOCbuttonList` function.
     */
    const CreatebuttonList = async (isAmo, isBOSelected, isModify, modifyData) => {
        let ignoreList = isAmo ? [...CURRENCYIgnoreList, "BO"] : CURRENCYIgnoreList;
        let FinalButtons = await CreateTOCbuttonList(nseBse, ignoreList, isAmo, isModify, modifyData, isBOSelected);
        return FinalButtons;
    };
    /**
     * The function `disableSell` returns a boolean value indicating whether the sell button should be
     * disabled based on certain conditions.
     * @returns The function `disableSell` returns a boolean value.
     */
    const disableSell = () => {
        return ((activeButton.PRODUCT === currencyProducts[2].title &&
            !tradeValues.agreeToTermsAndCondition) ||
            !activeButton.ORDER ||
            !activeButton.PRODUCT ||
            tradeValues.noOfLots <= "0" ||
            !quotesDetailsEntity ||
            Object.values(formErrors)
                .map((x) => x.status)
                .some((x) => x));
    };
    const createFormErrorFields = async (isSubmit) => {
        return new Promise((res, error) => {
            let getUIstatus = setUISectionsCurrency(activeButton, true);
            let isModify = checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.MODIFY);
            const validation = fieldValidationManager(tradeValues, activeState, quotesDetailsEntity[0]);
            res({
                limitPrice: !(getUIstatus === null || getUIstatus === void 0 ? void 0 : getUIstatus.disabledLimitInput)
                    ? isSubmit
                        ? validation === null || validation === void 0 ? void 0 : validation.getLimitValidation
                        : !tradeValues.limitPrice
                            ? { msg: "", status: true }
                            : validation === null || validation === void 0 ? void 0 : validation.getLimitValidation
                    : { msg: "", status: false },
                triggerPrice: getUIstatus.showTriggerPrice
                    ? isSubmit
                        ? validation === null || validation === void 0 ? void 0 : validation.getTriggerValidation
                        : !tradeValues.triggerPrice
                            ? { msg: "", status: true }
                            : validation === null || validation === void 0 ? void 0 : validation.getTriggerValidation
                    : { msg: "", status: false },
                stopLoss: getUIstatus.showStopLoss
                    ? isSubmit
                        ? validation === null || validation === void 0 ? void 0 : validation.getStoplossValidation
                        : !tradeValues.stopLoss && !isModify
                            ? { msg: "", status: true }
                            : validation === null || validation === void 0 ? void 0 : validation.getStoplossValidation
                    : { msg: "", status: false },
                target: getUIstatus.showTargetPrice
                    ? isSubmit
                        ? validation === null || validation === void 0 ? void 0 : validation.getTargetValidation
                        : !tradeValues.target && !isModify
                            ? { msg: "", status: true }
                            : validation === null || validation === void 0 ? void 0 : validation.getTargetValidation
                    : { msg: "", status: false },
                disclosedQuantity: isSubmit
                    ? validation === null || validation === void 0 ? void 0 : validation.getDisclossValidation
                    : { msg: "", status: false },
                // trailingStopLoss:
                //   trailingstop && !tradeValues.trailingstoploss
                //     ? { msg: "", status: true }
                //     : { msg: "", status: false },
            });
        });
    };
    /**
     * The function `getRmsHoldingsData` retrieves RMS holding details based on the user ID and symbol.
     */
    const getRmsHoldingsData = () => {
        const req = {
            userId: userID,
            symbol: quotesDetailsEntity ? quotesDetailsEntity[0].symbol : "",
        };
        if (userID)
            di.tocJourney.getRmsHoldingDetails(req);
    };
    /**
     * The function `getChargesData` sends a request to calculate broker charges based on the provided
     * parameters.
     */
    const getChargesData = () => {
        const req = {
            userID: userID,
            reqBody: {
                action: activeState,
                prd: getProductValues(buttonList, activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT),
                price: tradeValues.limitPrice,
                qty: (parseInt(tradeValues.noOfLots) *
                    parseInt(quotesDetailsEntity[0].lotSize)).toString(),
                sym: quotesDetailsEntity[0].symbol,
            },
        };
        di.tocJourney.brokerCharge(req);
    };
    const amoSelecterHandler = async (val, textContent) => {
        var _a, _b;
        await setAmoOrder(val);
        let isModify = (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
            ? checkTocState(locationState === null || locationState === void 0 ? void 0 : locationState.tocState, OrderbookTocStateEnum.MODIFY)
            : (props === null || props === void 0 ? void 0 : props.tocState)
                ? checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)
                : false;
        let isBOOrder = textContent === currencyProducts[2].title;
        let buttonList = await CreatebuttonList(val, isBOOrder, isModify, modifySection.modifyData);
        await setButtonList(buttonList === null || buttonList === void 0 ? void 0 : buttonList.products);
        await setOrderType(buttonList === null || buttonList === void 0 ? void 0 : buttonList.orderType);
        await setValidity(buttonList === null || buttonList === void 0 ? void 0 : buttonList.validity);
        if (val) {
            await setActiveButton(Object.assign(Object.assign({}, activeButton), { ORDER: (_a = currencyOrder[1]) === null || _a === void 0 ? void 0 : _a.title }));
            if (activeButton.PRODUCT === currencyProducts[2].value) {
                await setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: currencyProducts[0].title }));
            }
        }
        if (textContent) {
            await setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: textContent, ORDER: textContent == currencyProducts[2].value
                    ? (_b = currencyOrder[1]) === null || _b === void 0 ? void 0 : _b.title
                    : activeButton.ORDER }));
        }
    };
    const confirmOrderLoader = async (val) => {
        if (val) {
            await di.tocJourney.flushPlaceOrderError();
            await di.tocJourney.flushPlaceOrderData();
            setConfirmOrder(val);
        }
        else {
            setConfirmOrder(val);
        }
    };
    const removeMarginData = () => {
        di.tocJourney.flushMarginData();
    };
    /**
     * The function checks the margin and updates it if necessary, and closes the table of contents if
     * the device is not a desktop.
     */
    const closeTOC = () => {
        removeMarginData();
        // !device.isDesktop ? navigate(-1) : props.setShowTOC(false);
        navigate(-1);
    };
    const updateMargin = () => {
        di.tocJourney.checkMargin(refreshMargin);
    };
    const handleConfirmPage = useCallback(() => {
        return (React.createElement(OrderConfirmationMain, { setConfirmOrder: confirmOrderLoader, show: confirmOrder, orderConfirmationList: orderConfirmationBoList, amoOrder: amoOrder, exchange: nseBse, action: activeState, activeButton: activeButton, closeToc: closeTOC, tradeValues: tradeValues, tocState: modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, modifyData: modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData, afterModifyAction: props === null || props === void 0 ? void 0 : props.afterModifyAction, afterMarketRedirect: locationState === null || locationState === void 0 ? void 0 : locationState.redirectUrl, buttonList: buttonList }));
    }, [confirmOrder]);
    const proceedToPlaceOrder = async () => {
        await createFormErrorFields(true)
            .then((data) => {
            setFormErrors(data);
            if (Object.values(data)
                .map((x) => x.status)
                .some((x) => x)) {
                disableSell();
            }
            else {
                updateMargin();
                confirmOrderLoader(true);
            }
        })
            .catch((err) => { });
    };
    const getRmssSublimitsData = () => {
        if (userID) {
            di.tocJourney.getRmsSublimits(userID);
        }
    };
    const updateModifiedData = React.useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return {
            noOfLots: ((_a = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _a === void 0 ? void 0 : _a.netQty)
                ? (_b = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _b === void 0 ? void 0 : _b.netQty
                : "",
            trailingstoploss: "",
            quantity: (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0
                ? (_e = (+((_c = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _c === void 0 ? void 0 : _c.netQty) * parseInt((_d = quotesDetailsEntity[0]) === null || _d === void 0 ? void 0 : _d.lotSize))) === null || _e === void 0 ? void 0 : _e.toString()
                : "0",
            disclosedQuantity: +((_f = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _f === void 0 ? void 0 : _f.discloseQty) > 0
                ? (_g = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _g === void 0 ? void 0 : _g.discloseQty
                : "",
            limitPrice: ((_h = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _h === void 0 ? void 0 : _h.limitPrice)
                ? (_j = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _j === void 0 ? void 0 : _j.limitPrice
                : "",
            triggerPrice: ((_k = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _k === void 0 ? void 0 : _k.triggerPrice)
                ? (_l = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _l === void 0 ? void 0 : _l.triggerPrice
                : "",
            agreeToTermsAndCondition: true,
        };
    }, [modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData]);
    const handleValidityBtns = async (TOCIgnoreList) => {
        var _a, _b, _c, _d;
        let x = await getTOCProduct_OrderType_Val();
        return (_d = (_c = (_b = (_a = x.advanceOptions
            .find((y) => y.exc === nseBse)) === null || _a === void 0 ? void 0 : _a.validity) === null || _b === void 0 ? void 0 : _b.filter((p) => !(TOCIgnoreList === null || TOCIgnoreList === void 0 ? void 0 : TOCIgnoreList.includes(p.vaVal)))) === null || _c === void 0 ? void 0 : _c.map((l) => {
            var _a;
            return {
                title: l.vaVal,
                value: l.dpNm,
                disabled: false,
                rank: (_a = eqValidity.find((t) => {
                    return t.value == l.vaVal;
                })) === null || _a === void 0 ? void 0 : _a.rank,
            };
        })) === null || _d === void 0 ? void 0 : _d.sort((a, b) => a.rank - b.rank);
    };
    useEffect(() => {
        var _a, _b;
        if ((activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === currencyOrder[2].title &&
            ((_a = validity === null || validity === void 0 ? void 0 : validity.filter((x) => { var _a; return x.title == ((_a = currencyValidity[1]) === null || _a === void 0 ? void 0 : _a.title); })) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let TOCIgnoreList = ["IOC"];
            handleValidityBtns(TOCIgnoreList).then((x) => {
                setValidity(x);
            });
            setActiveButton(Object.assign(Object.assign({}, activeButton), { VALIDITY: (_b = validity[0]) === null || _b === void 0 ? void 0 : _b.title }));
        }
        else {
            let TOCIgnoreList = [""];
            handleValidityBtns(TOCIgnoreList).then((x) => {
                setValidity(x);
            });
        }
    }, [activeButton.ORDER]);
    useEffect(() => {
        var _a;
        if (quotesDetailsEntity &&
            (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0 &&
            !(props === null || props === void 0 ? void 0 : props.tocState) &&
            !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState)) {
            setTradeValues(Object.assign(Object.assign({}, tradeValues), { limitPrice: quotesDetailsEntity[0].lastTradedPrice, quantity: ((_a = quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.lotSize) || "1" }));
            getRmsHoldingsData();
        }
    }, [quotesDetailsEntity]);
    React.useEffect(() => {
        if (activeButton) {
            createFormErrorFields().then((data) => {
                setFormErrors(data);
            });
        }
    }, [activeButton, activeState, advancedOption]);
    useEffect(() => {
        !checkMarginLoader &&
            !checkMarginError.isOpen &&
            setMargin(checkMarginData);
    }, [checkMarginData, checkMarginLoader, checkMarginError]);
    useEffect(() => {
        !amoLoader &&
            !amoError.isOpen &&
            !(props === null || props === void 0 ? void 0 : props.tocState) &&
            !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState) &&
            amoSelecterHandler(amo === null || amo === void 0 ? void 0 : amo.status);
    }, [amo, amoLoader, amoError]);
    /* The above code is using the useEffect hook in a React component. It is setting the value of the
    "orderConfirmationBoList" state variable based on the values of other variables such as
    "activeState", "activeButton", and "tradeValues". It is creating an array of objects with titles
    and corresponding values, and then setting that array as the value of "orderConfirmationBoList".
    The useEffect hook is triggered whenever any of the dependencies (activeState, activeButton,
    tradeValues.noOfLots, tradeValues) change. */
    useEffect(() => {
        var _a, _b, _c, _d;
        activeButton &&
            tradeValues &&
            setOrderConfirmationBoList([
                {
                    title: "Action",
                    value: activeState,
                },
                {
                    title: "Product type",
                    value: (_a = buttonList === null || buttonList === void 0 ? void 0 : buttonList.find((x) => x.title === (activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT))) === null || _a === void 0 ? void 0 : _a.value,
                },
                {
                    title: "Order type",
                    value: (_b = orderType === null || orderType === void 0 ? void 0 : orderType.find((x) => x.title === (activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER))) === null || _b === void 0 ? void 0 : _b.title,
                },
                {
                    title: "No of Lots",
                    value: `${(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.noOfLots)
                        ? addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.noOfLots)
                        : ""} 
          ${(quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0 &&
                        ((_c = quotesDetailsEntity[0]) === null || _c === void 0 ? void 0 : _c.lotSize) &&
                        (tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.noOfLots)
                        ? `(Qty:${addCommasWithConditionalDecimal(Number((_d = quotesDetailsEntity[0]) === null || _d === void 0 ? void 0 : _d.lotSize) *
                            Number(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.noOfLots))})`
                        : ""}`,
                },
                {
                    title: "Limit price",
                    value: addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.limitPrice),
                    isHide: setUISections(activeButton, true).disabledLimitInput,
                },
                {
                    title: "Trigger price",
                    value: addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.triggerPrice),
                    isHide: !setUISections(activeButton, true).showTriggerPrice,
                },
                {
                    title: "Stop Loss",
                    value: `-${addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.stopLoss)} pts`,
                    isHide: !setUISections(activeButton, true).showStopLoss,
                },
                {
                    title: "Target",
                    value: `+${addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.target)} pts`,
                    isHide: !setUISections(activeButton, true).showTargetPrice,
                },
                // {
                //   title: "Trailing Stop Loss",
                //   value: `+${addCommasWithoutDecimal(
                //     tradeValues?.trailingstoploss
                //   )} pts`,
                //   isHide: !trailingstop,
                // },
            ]);
    }, [activeState, activeButton, margin, tradeValues, trailingstop]);
    // Orignal Code
    // useEffect(() => {
    //   getRmssSublimitsData();
    //   if (!device.isDesktop && location && locationState?.Authsymbol) {
    //     AuthToSellJourney().multiquote(location, locationState?.Authsymbol);
    //   }
    //   if (localStorage.getItem("acc_data")) CreatebuttonList();
    // }, []);
    // Changes for Testing
    useEffect(() => {
        if (userID) {
            getRmssSublimitsData();
            if (params === null || params === void 0 ? void 0 : params.symbol) {
                AuthToSellJourney().multiquote(location, params === null || params === void 0 ? void 0 : params.symbol);
                const payload = {
                    symbol: params === null || params === void 0 ? void 0 : params.symbol,
                };
                mainDi.common.getScripDetailData(payload);
            }
            if (localStorage.getItem("acc_data") &&
                !(props === null || props === void 0 ? void 0 : props.tocState) &&
                !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState))
                CreatebuttonList(amoOrder).then((list) => {
                    setButtonList(list === null || list === void 0 ? void 0 : list.products);
                    setOrderType(list === null || list === void 0 ? void 0 : list.orderType);
                    setValidity(list === null || list === void 0 ? void 0 : list.validity);
                });
        }
    }, [params, userID]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (updateModifiedData && ((props === null || props === void 0 ? void 0 : props.tocState) || (locationState === null || locationState === void 0 ? void 0 : locationState.tocState))) {
            setTradeValues(updateModifiedData);
            setNseBse(((_a = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _a === void 0 ? void 0 : _a.exchange)
                ? (_b = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _b === void 0 ? void 0 : _b.exchange
                : nseBse);
            createFormErrorFields().then((data) => {
                setFormErrors(data);
            });
            let isModify = (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
                ? checkTocState(locationState === null || locationState === void 0 ? void 0 : locationState.tocState, OrderbookTocStateEnum.MODIFY)
                : (props === null || props === void 0 ? void 0 : props.tocState)
                    ? checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)
                    : false;
            let modifyData = (locationState === null || locationState === void 0 ? void 0 : locationState.modifyData)
                ? locationState === null || locationState === void 0 ? void 0 : locationState.modifyData
                : props === null || props === void 0 ? void 0 : props.modifyData;
            setModifySection({
                tocState: (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
                    ? locationState === null || locationState === void 0 ? void 0 : locationState.tocState
                    : props === null || props === void 0 ? void 0 : props.tocState,
                modifyData: modifyData,
            });
            setAmoOrder((_c = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _c === void 0 ? void 0 : _c.isAmo);
            let isBOOrder = (modifyData === null || modifyData === void 0 ? void 0 : modifyData.productType) == currencyProducts[2].title;
            CreatebuttonList((_d = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _d === void 0 ? void 0 : _d.isAmo, isBOOrder, isModify, modifyData).then((list) => {
                setButtonList(list === null || list === void 0 ? void 0 : list.products);
                setOrderType(list === null || list === void 0 ? void 0 : list.orderType);
                setValidity(list === null || list === void 0 ? void 0 : list.validity);
            });
            setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: (_e = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _e === void 0 ? void 0 : _e.productType, ORDER: (_f = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _f === void 0 ? void 0 : _f.orderType, VALIDITY: (_g = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _g === void 0 ? void 0 : _g.validity }));
        }
    }, [updateModifiedData]);
    return (React.createElement(React.Fragment, null, confirmOrder ? (React.createElement(React.Fragment, null, handleConfirmPage())) : charges ? (React.createElement(ChargesMain, { show: charges, setShow: setCharges })) : marketDepth ? (React.createElement(MarketDepth, { setmarketDepth: setmarketDepth, show: marketDepth, isTabHide: true })) : chartIQ ? (React.createElement(ChartIQTOC, { symbol: quotesDetailsEntity ? quotesDetailsEntity[0].symbol : "", instru: quotesDetailsEntity ? quotesDetailsEntity[0].asTyp : "", show: chartIQ, goBack: () => setChartIQ(false) })) : (React.createElement(React.Fragment, null, termCondition ? (React.createElement(TermsAndConditions, { show: termCondition, setShow: setTermCondition })) : understanding ? (React.createElement(UnderStandingMain, { show: understanding, setShow: setUnderstanding, content: React.createElement(GenericTabs, { defaultActiveKey: underStandingSectionKey, tabsArray: [
                {
                    title: "Product Type",
                    eventKey: understandingSectionEnum.PRODUCT,
                    tabContent: (React.createElement(UnderStanding, { data: productData, activeKey: activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT })),
                },
                {
                    title: "Order Type",
                    eventKey: understandingSectionEnum.ORDER,
                    tabContent: (React.createElement(UnderStanding, { data: orderData, activeKey: activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER })),
                },
            ] }) })) : (React.createElement(React.Fragment, null,
        React.createElement(TocStockHeader, { children: React.createElement(StockQuote, { stockQuoteDetails: quotesDetailsEntity, exchangeType: nseBse, textInsteadToggle: true, hideHoldings: true, setChartIQ: () => setChartIQ(true), maximumFractionDigits: 4 }) }),
        React.createElement(CurrencyProductOrder, { buttonList: buttonList, multiQuoteEntity: (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0
                ? quotesDetailsEntity[0]
                : {}, setTermCondition: setTermCondition, setUnderStandingSectionKey: setUnderStandingSectionKey, setUnderstanding: setUnderstanding, setmarketDepth: setmarketDepth, orderType: orderType, validity: validity, tradeValues: tradeValues, setActiveButton: setActiveButton, activeButton: activeButton, setTradeValues: setTradeValues, activeState: activeState, setrefreshMargin: setrefreshMargin, margin: margin, advancedOption: advancedOption, setAdvancedOption: setAdvancedOption, trailingstop: trailingstop, seTrailingStop: seTrailingStop, formErrors: formErrors, setFormErrors: setFormErrors, amoOrder: amoOrder, setAmoOrder: amoSelecterHandler, isModifyOrder: checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.MODIFY), modifyData: modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData }),
        React.createElement("div", { className: "bottom-contents" },
            React.createElement(MarginReqAvail, { setCharges: setCharges, getChargesData: getChargesData, updateMargin: updateMargin, margin: margin, disableCharges: chargesHandler(tradeValues), availableCash: rmsSublimits.cshAvl }),
            React.createElement(BuySellBtn, { refreshLabelTitle: !IsBuy ? TOCBUYORSELL.BUY : TOCBUYORSELL.SELL, buySellRefresh: true, cancelAction: closeTOC, rightButton: {
                    btnTyp: activeState === TOCBUYORSELL.SELL
                        ? "red-btn"
                        : "green-btn",
                    value: activeState,
                    className: "w-100",
                    onClick: () => proceedToPlaceOrder(),
                    disabled: disableSell(),
                }, onCallBackFunction: () => {
                    setIsBuy(!IsBuy);
                    setActiveState(!IsBuy ? TOCBUYORSELL.BUY : TOCBUYORSELL.SELL);
                } }))))))));
};
export default Currency;
